var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVariationLow = function SvgVariationLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.697 13.928c-1.64.242-3.301-.09-4.872-1.528a1 1 0 1 1 1.35-1.476c1.086.994 2.126 1.188 3.23 1.025 1.14-.168 2.322-.71 3.697-1.34l.217-.1c1.396-.638 2.988-1.346 4.65-1.484 1.738-.145 3.496.334 5.206 1.9a1 1 0 0 1-1.35 1.475c-1.3-1.19-2.508-1.48-3.691-1.382-1.26.105-2.546.653-3.983 1.31l-.296.136c-1.29.593-2.723 1.252-4.158 1.464Z",
    clipRule: "evenodd"
  })));
};

export default SvgVariationLow;